module.exports = __webpack_public_path__ + "images/application/templates/layout-basic-full@2x-093d461c.png";